export default {
    translateListing(listing) {
        let listings = {
            "fm-approved": "FM Approved",
            "ul-listed": "UL Listed",
            "oshpd": "OSHPD"
        };

        return listings[listing];
    }
};
